<template>
  <div class="flex flex-col gap-4">
    <!-- Search Input -->
    <div class="flex gap-4 items-center">
      <div class="flex-grow">
        <AppInputText
          name="search"
          v-model="searchQuery"
          :placeholder="`Search ${viewContext} events`"
          :required="false"
        >
          <template #prefix>
            <i class="fas fa-search text-normal-reduced"></i>
          </template>
        </AppInputText>
      </div>
      <div class="flex-shrink-0">
          <AppButtonCircle 
            sizeClass="w-[44px] h-[44px]"
            icon="fas fa-add" 
            @click="newEvent"
          />
      </div>
    </div>
    
    <!-- Loading State -->
    <AppLoading v-if="isLoading" :loading="isLoading"></AppLoading>

    <!-- Empty State -->
     <AppEmptyState
      v-else-if="!events || events.length === 0"
      icon="far fa-calendar-days"
      :item-name="`${viewContext} events`"
      button-text="Create Event"
      @action="newEvent"
    />

    <!-- Events Grid -->
    <div v-else-if="filteredEvents.length > 0" 
      class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
      <ManageEventListItem
        v-for="event in filteredEvents"
        :key="event.id"
        :poker-run-event="event"
        @click="$emit('eventClick', event)"
      />
    </div>
    
    <!-- No Search Results -->
    <div v-else class="text-center py-2 text-normal-reduced">
      No events found matching your search

    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { PokerRunEvent } from "@models/PokerRunEvent";
import ManageEventListItem from "./ManageEventListItem.vue";
import AppButton from "./AppButton.vue";
import AppButtonCircle from "./AppButtonCircle.vue";
import AppInputText from "./AppInputText.vue";
import { useRouter } from "vue-router";
import AppEmptyState from './AppEmptyState.vue';
const router = useRouter();

const props = defineProps<{
  events: PokerRunEvent[]
  viewContext: string
  isLoading: boolean
}>();

const emit = defineEmits<{
  (e: 'eventClick', event: PokerRunEvent): void
}>();

const searchQuery = ref('');

const filteredEvents = computed(() => {
  if (!searchQuery.value) return props.events ?? [];
  
  const query = searchQuery.value.toLowerCase();
  return props.events.filter(event => 
    event.name.toLowerCase().includes(query) 
  );
});

const newEvent = () => {
  router.push({ name: "ManageNewEvent" });
};

</script>
